import { render } from "./Index.vue?vue&type=template&id=137b853a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=137b853a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137b853a"],['__file',"components/Auth/Password/Reset/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "137b853a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('137b853a', __exports__)) {
    api.reload('137b853a', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=137b853a&scoped=true", () => {
    api.rerender('137b853a', render)
  })

}


export default __exports__